export default "__VITE_ASSET__25856252__"